import { Globe, ArrowUpRight } from "lucide-react";

const HUB_URL = "https://www.nasha-hub.com";

export default function NasaHubCTA() {
  return (
    <div className="w-full flex justify-center pt-2 pb-4" data-testid="nasa-hub-section">
      <a
        href={HUB_URL}
        data-testid="nasa-hub-cta"
        className="nasa-hub-link group relative inline-flex items-center gap-3 md:gap-4 px-6 md:px-10 py-4 md:py-5 rounded-sm overflow-hidden"
      >
        <span className="relative z-10 flex items-center gap-3 md:gap-4">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-sm bg-[#22ff77] text-black flex items-center justify-center shrink-0 group-hover:rotate-12 transition-transform">
            <Globe className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.5} />
          </span>
          <span className="text-left">
            <span className="block text-[9px] md:text-[10px] uppercase tracking-[0.4em] text-[#22ff77] mb-0.5">
              NAŠA Community
            </span>
            <span className="block font-display text-sm md:text-base font-bold tracking-wide text-white">
              NAŠA HUB Community — <span className="text-[#22ff77]">Otvori NAŠA HUB</span>
            </span>
          </span>
          <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5 text-[#22ff77] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </a>
      <style>{`
        .nasa-hub-link {
          background: linear-gradient(135deg, rgba(34,255,119,0.10), rgba(34,255,119,0.05)), #0a0a0a;
          box-shadow: 0 0 0 1px rgba(34,255,119,0.35), 0 0 30px rgba(34,255,119,0.15), inset 0 0 20px rgba(0,0,0,0.6);
          animation: hub-pulse 3.4s ease-in-out infinite;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .nasa-hub-link:hover {
          transform: translateY(-2px);
          box-shadow: 0 0 0 1px rgba(34,255,119,0.85), 0 0 50px rgba(34,255,119,0.4);
          animation-play-state: paused;
        }
        @keyframes hub-pulse {
          0%, 100% { box-shadow: 0 0 0 1px rgba(34,255,119,0.35), 0 0 30px rgba(34,255,119,0.15); }
          50% { box-shadow: 0 0 0 1px rgba(34,255,119,0.6), 0 0 50px rgba(34,255,119,0.3); }
        }
      `}</style>
    </div>
  );
}
